<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>
<script lang="ts" setup>
import type {Area} from "#magnolia-layer/types/magnolia-types";

const props = defineProps<{
  metadata: Area;
  body?: string;
}>();
</script>

<template>
  <div class="inner-content-grid article-margin">
    <div
      v-if="body"
      class="apply-content-styles text-lg lg:text-xl"
      v-html="body"></div>
  </div>

  <!--  &lt;!&ndash; TODO: add like a article footer area that can only hold this one - as it it's specfic w the border before hte page footer &ndash;&gt;-->
  <!--  <div-->
  <!--    class="col-span-full bg-white border-y-[1px] border-neutral-300 mb-20 last-of-type:mb-0">-->
  <!--    <br />-->
  <!--    <br />-->
  <!--    <br />-->
  <!--    <br />-->
  <!--    <br />-->
  <!--  </div>-->
</template>

<style lang="scss" scoped>
.apply-content-styles {
  > *:first-child {
    @apply mt-4;
  }
  > * {
    @apply mb-4;
  }

  :deep(h2) {
    @apply text-3xl mb-8;
  }

  :deep(h3) {
    @apply text-2xl mb-4 mt-8;
  }

  :deep(h4) {
    @apply text-xl font-sans uppercase font-bold mb-4 mt-8;
  }
  :deep(ol) {
    @apply list-decimal pl-4 ml-2;
  }
  :deep(ul) {
    @apply list-disc pl-4 ml-2;
  }
}
</style>
